import { aboutPoints } from "@/mocks/evidence";
import Reveal from "./Reveal";
import { SectionHeading } from "./Ui";

export default function About() {
  return (
    <section id="about" className="bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          <Reveal>
            <div>
              <SectionHeading
                eyebrow="About · 关于本站"
                title="把材料摆出来，把结论留给你判断"
              />
              <p className="max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">
                八酱黑料是一个以实锤证据挖掘为取向的整理归档站点。我们做的不是下结论，而是
                <strong className="font-semibold text-foreground-950">把可查证的截图、录音、视频汇总起来</strong>
                ，再逐项拆解争议点、标注证据链完整度。所有材料均保留原始指向与时间信息，供读者自行复核。
              </p>
              <div className="mt-6 space-y-3">
                {aboutPoints.map((p, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-600 text-background-50">
                      <i className="ri-check-line flex h-3.5 w-3.5 items-center justify-center text-sm" />
                    </span>
                    <p className="text-sm leading-relaxed text-foreground-700">{p}</p>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="border-b border-background-200 bg-background-200/60 p-5">
                <h3 className="font-heading text-base font-semibold text-foreground-950">
                  如何参与 / 提供线索
                </h3>
                <p className="mt-1 text-xs text-foreground-600">
                  如果你持有可溯源的第一手材料，可附上原始来源与时间信息提交。
                </p>
              </div>
              <div className="space-y-4 p-5">
                <div className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className="ri-mail-send-line flex h-5 w-5 items-center justify-center text-xl" />
                  </span>
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-foreground-900">线索信箱</p>
                    <p className="truncate text-xs text-foreground-500">leak@example.com</p>
                  </div>
                </div>
                <div className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className="ri-shield-check-line flex h-5 w-5 items-center justify-center text-xl" />
                  </span>
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-foreground-900">核验反馈</p>
                    <p className="text-xs leading-relaxed text-foreground-500">
                      对结论等级有异议？提供反证材料即可发起复核。
                    </p>
                  </div>
                </div>
                <p className="text-xs leading-relaxed text-foreground-500">
                  说明：本站内容仅作资料整理与争议梳理用途，不构成对任何主体的法律认定或诽谤性结论；转载请注明出处。
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}